import React from 'react';
import ApplicationStatus from '../components/ApplicationStatus';
import UsersByRole from '../components/UsersByRole';
import OnboardedCandidates from '../components/Onboarded';
import RecruiterScorecard from '../components/RecruiterScoreCard';
import MonthlyData from '../components/Monthlydata';
import JobProgress from '../components/JobProgress';
import CandidateBySource from '../components/CandidateBySource';
import RecruitmentsReport from '../components/RecruitmentsReport';

const Statistics = () => {
  return (
    <div>
      <UsersByRole />
      <RecruiterScorecard />

      <div className='stat-container'>
        <div className='stat-repo2'>
          <MonthlyData />
        </div>
        <div className='stat-repo1'>
          <CandidateBySource />
        </div>
      </div>
      <div className='stat-container'>
        <div className='stat-repo1'>
          <ApplicationStatus />
        </div>
        <div className='stat-repo2'>
          <OnboardedCandidates />
        </div>
      </div>
      <div >
        <RecruitmentsReport />
      </div>
    </div>
  );
};

export default Statistics;
